import { Link, createFileRoute } from "@tanstack/react-router";

const TITLE = "Page Not Found — Light of Life International";
const DESCRIPTION = "The page you were looking for isn't here. Return home to keep exploring.";

/** Preserved legacy URL from the source site, where it also returns a 404 page. */
export const Route = createFileRoute("/contact-us")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ContactUsPage,
});

function ContactUsPage() {
  return (
    <section className="relative flex min-h-[70svh] items-center justify-center overflow-hidden">
      <img src="/media/vm06.webp" alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="hero-scrim absolute inset-0" aria-hidden />
      <div className="container-site relative max-w-2xl py-24 text-center">
        <h1 className="text-6xl text-white sm:text-7xl">404</h1>
        <h2 className="mt-4 text-3xl text-white sm:text-4xl">oops... Page not found</h2>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="rounded-lg bg-accent px-8 py-3 font-sans font-semibold text-navy transition hover:brightness-110"
          >
            Return to Home
          </Link>
          <Link
            to="/contact"
            className="rounded-lg border border-white px-8 py-3 font-sans font-semibold text-white transition hover:bg-white/10"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
}
